import { render, staticRenderFns } from "./MsgDetail.vue?vue&type=template&id=47856301&scoped=true"
import script from "./MsgDetail.vue?vue&type=script&lang=js"
export * from "./MsgDetail.vue?vue&type=script&lang=js"
import style0 from "./MsgDetail.vue?vue&type=style&index=0&id=47856301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47856301",
  null
  
)

export default component.exports